/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { Icon } from '@fitinsur/components'

import * as Styled from './styles';

import { GeneralSection } from '../index';

function RenderSectionAddAndRemoveRowButtons({
  partySectionName,
  sectionState,
  setSectionState,
  index,
  questions,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  onRemove = null
}) {
  return (
    <>
      {index !== 0 &&
        <Styled.IconButton style={{ marginBottom: '15px' }} onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const newArray = sectionState.filter((v, i) => i !== index);
          setSectionState(newArray);

          const groupQuestionnaireAnswersToDelete = questions.map(
            question => question.idQuestionnaireAnswers
          ).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)

          setQuestionnaireAnswersToDelete([
            ...questionnaireAnswersToDelete,
            ...groupQuestionnaireAnswersToDelete
          ])
          
          if (onRemove) {
            onRemove(newArray, groupQuestionnaireAnswersToDelete);
          }
        }}>
          <Icon name="trash" style={{ margin: 0 }} />
        </Styled.IconButton>
      }

      {index === sectionState.length - 1 &&
        <Styled.IconButton onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const newArray = [...sectionState, GeneralSection.events.createSectionRow({ questions })];

          setSectionState(newArray)
        }}>
          <Icon name="plus" style={{ margin: 0 }} />
        </Styled.IconButton>
      }
    </>
  )
}

function RenderSectionAddRowButton({
  sectionState,
  setSectionState,
  questions,
}) {
  return (
    <Styled.IconButton onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      const newArray = [...sectionState, GeneralSection.events.createSectionRow({ questions })];

      setSectionState(newArray)
    }}>
      <Icon name="plus" style={{ margin: 0 }} />
    </Styled.IconButton>
  )
}

function RenderSectionRemoveRowButton({
  sectionState,
  setSectionState,
  index,
  questions,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  return (
    <Styled.IconButton style={{ marginBottom: '15px' }} onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      const newArray = sectionState.filter((v, i) => i !== index);
      setSectionState(newArray);
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...questions.map(
          question => question.idQuestionnaireAnswers
        ).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
      ])
    }}>
      <Icon name="trash" style={{ margin: 0 }} />
    </Styled.IconButton>
  )
}


const components = {
  Styled,
  RenderSectionAddAndRemoveRowButtons,
  RenderSectionAddRowButton,
  RenderSectionRemoveRowButton
}

export { components }